/** @internal */
export const CONSTANTS = {
	FETCH_CONVERSATIONS: 'FETCH_CONVERSATIONS',
	FETCH_CONVERSATIONS_SUCCESS: 'FETCH_CONVERSATIONS_SUCCESS',
	FETCH_CONVERSATIONS_FAILURE: 'FETCH_CONVERSATIONS_FAILURE',
	FETCH_CONVERSATIONS_AUTH: 'FETCH_CONVERSATIONS_AUTH',
	FIND_MATCHING_CONVERSATION: 'FIND_MATCHING_CONVERSATION',
	CLEAR_CONVERSATIONS: 'CLEAR_CONVERSATIONS',
};

/** @internal */
export const initialState = {
	conversationId: null,
	conversations: [],
	error: null,
	isFetching: false,
	vendorIdsWithConversations: [],
};

export default function convoReducer(state = initialState, action) {
	switch (action.type) {
		case CONSTANTS.FETCH_CONVERSATIONS_AUTH:
			return { ...state, isFetching: true };
		case CONSTANTS.FETCH_CONVERSATIONS:
			return { ...state, isFetching: true };
		case CONSTANTS.FETCH_CONVERSATIONS_SUCCESS:
			return {
				...state,
				isFetching: false,
				conversations: action.response.conversations,
				vendorIdsWithConversations: action.response.conversations.map(
					(obj) => obj.storefrontInfo.id,
				),
			};
		case CONSTANTS.FETCH_CONVERSATIONS_FAILURE:
			return { ...state, isFetching: false, error: action.error };
		case CONSTANTS.FIND_MATCHING_CONVERSATION:
			return { ...state, conversationId: action.response };
		case CONSTANTS.CLEAR_CONVERSATIONS:
			return { ...state, conversations: null, conversationId: null };
		default:
			return state;
	}
}
